import React from "react";
import "./ProjectsDataTableRow.scss";
import classNames from "classnames";
import { useSelector } from "react-redux";

export function ProjectsDataTableRow(props) {
  const { selectedProjects } = useSelector((state) => state.projectReducer);

  const projectData = props.children[0]?.props?.cell?.row?.original;

  const isSelected = selectedProjects.find(
    (selectedProject) => selectedProject.id === projectData?.projectId,
  );

  return (
    <tr
      className={classNames([
        "projects-data-table__row",
        props.isHeader && "projects-data-table__row--header",
        isSelected && "projects-data-table__row--highlighted",
      ])}
      {...props}
      data-project-name={projectData?.projectName.props.project.projectName}
      key={projectData?.projectName.props.project.projectName || "headerRow"}
    />
  );
}
